export default "__VITE_ASSET__CiWs46WO__"